// /client/src/hooks/useAnalytics.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsManager from '../utils/analytics';

// Custom hook for tracking page views with React Router
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay to ensure page title is updated
    const timeoutId = setTimeout(() => {
      const pageTitle = document.title;
      const pagePath = location.pathname + location.search;
      
      // Track page view if analytics is enabled
      analyticsManager.trackPageView(pagePath, pageTitle);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [location]);
};

// Hook for tracking custom events
export const useEventTracking = () => {
  const trackEvent = (eventName, parameters = {}) => {
    analyticsManager.trackEvent(eventName, parameters);
  };

  const trackButtonClick = (buttonName, location) => {
    trackEvent('button_click', {
      button_name: buttonName,
      page_location: location || window.location.pathname
    });
  };

  const trackFormSubmission = (formName, success = true) => {
    trackEvent('form_submit', {
      form_name: formName,
      success: success
    });
  };

  const trackMenuItemClick = (menuItem) => {
    trackEvent('menu_click', {
      menu_item: menuItem
    });
  };

  return {
    trackEvent,
    trackButtonClick,
    trackFormSubmission,
    trackMenuItemClick
  };
};

export default usePageTracking;